import { render } from "./default.vue?vue&type=template&id=7dcfa018&scoped=true"
const script = {}

import "./default.vue?vue&type=style&index=0&id=7dcfa018&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcfa018"]])

export default __exports__